<woa-modal-page-layout [showRefreshButton]="true" (onRefresh)="loadMemberSummary()"
                       [title]="configurationModel.isConsumerActor() ? 'woa.heading.deals.consumerTitle' : 'woa.heading.deals.waiterTitle'"
                       [showSubtitle]="status() === LoadingStatus.LOADED"
                       [subtitle]="(nrDeals() == 0 ? 'woa.label.deals.noDeals' : nrDeals() == 1 ? 'woa.label.deals.oneDeal' : 'woa.label.deals.manyDeals')"
                       [translationParams]="{'nrDeals': nrDeals()}">
    @if (status() === LoadingStatus.LOADED) {
        <div class="deals" woa-touchable>
            @if (configurationModel.isConsumerActor()) {
                @if (identityModel.promoteMemberLogin()) {
                    <div class="deals-deal" woa-responsive woa-element-width>
                        <woa-promo-card [title]="configurationModel.app()?.promoteMemberLoginText1"
                                        [message]="configurationModel.app()?.promoteMemberLoginText2"
                                        [image]="configurationModel.app()?.promoteMemberLoginImage"
                                        [autoCropImage]="configurationModel.app()?.promoteMemberLoginImageAutoCrop"
                                        [actionLabel]="'woa.common.login' | translate"
                                        (onActivate)="login()"></woa-promo-card>
                    </div>
                }
                @if (memberDeals().length) {
                    <div class="deals-heading">
                        {{ 'woa.heading.deals.memberDeals' | translate }}
                    </div>
                }
                @for (deal of memberDeals(); track deal; let i = $index) {
                    <div class="deals-deal" woa-element-width>
                        <woa-promo-card [deal]="deal" [showCodeLink]="true" id="member-deal-{{i}}"
                                        (onActivate)="orderDeal(deal)"></woa-promo-card>
                    </div>
                }
                @if ((appDeals().length || allUntriggeredCardPromos().length) && memberDeals().length) {
                    <div class="deals-heading">
                        {{ (memberDeals().length ? 'woa.heading.deals.appDeals.withMemberDeals' : 'woa.heading.deals.appDeals.withoutMemberDeals') | translate }}
                    </div>
                }
            }
            @for (deal of appDeals(); track deal; let i = $index) {
                <div class="deals-deal" woa-responsive woa-element-width>
                    <woa-promo-card [deal]="deal" [showCodeLink]="true" id="app-deal-{{i}}"
                                    (onActivate)="orderDeal(deal)"></woa-promo-card>
                </div>
            }
            @if (configurationModel.isConsumerActor()) {
                @for (promo of allUntriggeredCardPromos(); track promo) {
                    <div class="deals-deal" woa-responsive woa-element-width>
                        <woa-promo-card [promo]="promo" [suppressProducts]="false"
                                        (onActivate)="promoActioned(promo, $event)"></woa-promo-card>
                    </div>
                }
            }
        </div>
    }
    <woa-button woa-page-footer-control [label]="'woa.button.deals.enterDealCode'"
                (onActivate)="enterDealCode()"></woa-button>
</woa-modal-page-layout>
